import { Market } from "@config/site/types";
import { activeSiteConfig } from "@config/site/site-config";

// The address can be missing entirely, e.g. Click & Reserve orders have no shipping address.
export const formatStreet = (address?: { street1?: string; street2?: string } | null) => {
    return (
        [address?.street1, address?.street2]
            .filter(Boolean)
            .join(", ")
            // Some streetnames end with a comma which we want to remove since we add it ourselves
            .replaceAll(/,+/g, ",")
            .trim()
    );
};

type CityFormatter = ({
    city,
    region,
    postalCode,
}: {
    city?: string;
    region?: string;
    postalCode?: string;
}) => string;

const cityFormatters: Record<string, CityFormatter> = {
    [Market.AU]: ({ city, region, postalCode }) =>
        [city, region, postalCode].filter(Boolean).join(" ").replaceAll(/\s+/g, " ").trim(),
};
const defaultCityFormatter: CityFormatter = ({ city, postalCode }) => {
    return [postalCode, city].filter(Boolean).join(" ").replaceAll(/\s+/g, " ").trim();
};

export const formatCityLine: CityFormatter = (args) => {
    const market = activeSiteConfig.country.toLowerCase();
    const formatter = cityFormatters[market] || defaultCityFormatter;
    return formatter(args);
};
